import "./App.scss";
import "./lib/form/form.scss";
import Navi from "./components/Navi";
import Mainbg from "./components/Mainbg";
import Footer from "./components/Footer";
import Main from "./pages/Main";
import Sub from "./pages/Sub";
import Certified from "./pages/Service/Certified";
import Request from "./pages/Service/Request";
import Notice from "./pages/Board/Notice";
import Institution from "./pages/Service/Institution";
import Authinfo from "./pages/Service/Authinfo";
import Addfile from "./pages/Service/Addfile";
import { Routes, Route } from "react-router-dom";
import NoticeDetail from "./pages/Board/NoticeDetail";
import Customerqa from "./pages/CustomerBoard/Customerqa";
import CustomerqaDetail from "./pages/CustomerBoard/CustomerqaDetail";
import Announcement from "./pages/Board/Announcement";
import Disclosure from "./pages/Board/Disclosure";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import Usersignup from "./pages/Auth/Usersignup";
import Committeesignup from "./pages/Auth/Committeesignup";
import My from "./pages/MyPage/my";
import Breakdown from "./pages/MyPage/Breakdown";
import Cits from "./pages/MyPage/Cits";
import LogOutOK from "./pages/Auth/Logout";
import Standard from "./pages/Board/Standard";
import Userlogin from "./pages/Auth/Userlogin";
import Committee from "./pages/Auth/Committee";
import Location from "./pages/Location";
import MyCommittee from "./pages/MyPage/MyCommittee";
import Dataroom from "./pages/CustomerBoard/Dataroom";
import CommitteeMy from "./pages/MyPage/CommitteeMy";
import ApplicationMycommittee from "./components/ApplicationMycommittee";
import Committeeprocess from "./pages/Committee/Committeeprocess";
import Committeeprocess2 from "./pages/Committee/Committeeprocess2";
import Committeeprocess3 from "./pages/Committee/Committeeprocess3";
import Committeefair from "./pages/Committee/Committeefair";
import ReviewCompletionStatus from "./pages/CompleteService/ReviewCompletionStatus";
import ReviewCompletionStatusDetail from "./pages/CompleteService/ReviewCompletionStatusDetail";
import Stepper from "./pages/MyPage/Stepper";
import StepperDetail from "./pages/MyPage/StepperDetail";
import Error from "./pages/Error";
import Succession from "./pages/MyPage/Succession";
import SuccessionDetail from "./pages/MyPage/SuccessionDetail";
import CommitteeInfoDetail from "./pages/Committee/CommitteeInfoDetail";
import useErrorHandler from "./api/errorInterceptor";

function App() {
  useErrorHandler();
  return (
    <>
      <div className="App">
        <div className="main">
          <Navi />
          <div style={{ height: "60px" }}></div>
          <div className="contain">
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/sub" element={<Sub />} />
              <Route path="/certified/*" element={<Certified />}></Route>
              <Route path="/login" element={<Login />}>
                <Route path="userlogin" element={<Userlogin />} />
                <Route path="committee" element={<Committee />} />
              </Route>
              <Route path="/signup" element={<Signup />}></Route>
              <Route path="usersignup" element={<Usersignup />} />
              <Route path="committeesignup" element={<Committeesignup />} />
              <Route path="/my" element={<My />} />
              {/* <Route path="/notification" element={<NotificationUserMy />} />
              <Route
                path="/notification/:id"
                element={<NotificationUserMyDetail />}
              /> */}

              <Route path="/committeemy" element={<CommitteeMy />}>
                <Route path="mycommittee" element={<MyCommittee />} />
                <Route
                  path="applicationMycommittee"
                  element={<ApplicationMycommittee />}
                />
                {/* <Route
                  path="notification/"
                  element={<NotificationCommitteeMy />}
                />
                <Route
                  path="notification/:id"
                  element={<NotificationCommitteeMyDetail />}
                /> */}
              </Route>

              {/* 위원회 */}
              <Route
                path="committeeprocess/:id"
                element={<Committeeprocess />}
              />
              <Route
                path="committeeprocess/:id/info/*"
                element={<Committeeprocess2 />}
              >
                <Route path=":did" element={<CommitteeInfoDetail />} />
              </Route>
              <Route
                path="committeeprocess/:id/member"
                element={<Committeeprocess3 />}
              />
              <Route path="committeefair" element={<Committeefair />} />
              {/* <Route
                path="committeecertified"
                element={<Committeecertified />}
              />
              <Route path="committeestandard" element={<Committeestandard />} /> */}
              {/* 위원회 끝 */}

              <Route path="/location" element={<Location />} />
              <Route path="Logout" element={<LogOutOK />} />
              <Route path="/breakdown" element={<Breakdown />}>
                <Route path="cits/*" element={<Cits />}>
                  {/* <Route path="mytabcits" element={<MyTabCits />} /> */}
                </Route>
              </Route>
              <Route path="/succession" element={<Succession />}>
                <Route path=":id" element={<SuccessionDetail />} />
              </Route>
              <Route path="/stepper" element={<Stepper />}>
                <Route path=":id" element={<StepperDetail />} />
              </Route>
              <Route
                path="/reviewcompletionstatus/*"
                element={<ReviewCompletionStatus />}
              >
                <Route path=":id" element={<ReviewCompletionStatusDetail />} />
              </Route>

              <Route path="/notice/*" element={<Notice />}>
                <Route path=":id" element={<NoticeDetail />} />
              </Route>
              <Route path="/Announcement/*" element={<Announcement />}>
                <Route path=":id" element={<NoticeDetail />} />
              </Route>
              <Route path="/disclosure/*" element={<Disclosure />}>
                <Route path=":id" element={<NoticeDetail />} />
              </Route>
              <Route path="/standard/*" element={<Standard />}>
                <Route path=":id" element={<NoticeDetail />} />
              </Route>
              <Route path="/customerqa/*" element={<Customerqa />}>
                {/* <Route path=":id" element={<CustomerqaDetail />} /> */}
              </Route>
              <Route path="/dataroom/*" element={<Dataroom />}>
                <Route path=":id" element={<NoticeDetail />} />
              </Route>
              <Route path="/request" element={<Request />}>
                <Route path="institution" element={<Institution />} />
                <Route path="authinfo" element={<Authinfo />} />
                <Route path="addfile" element={<Addfile />} />
              </Route>
              <Route path="*" element={<Error />} />
            </Routes>
          </div>
        </div>
      </div>

      <Mainbg />
      <Footer />
    </>
  );
}

export default App;
